import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const DeleteConfirmationModal = ({ show, handleClose, handleConfirm, content }) => {
  return (
    <Modal show={show} onHide={handleClose} className="modal-delete">
      <div className="warning-content">
        <div className="warningOuter">
          <div className="alertImg">
            <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
          </div>
          <div className="warningText">
            Are you sure you want to delete this {content ?? 'record'}?
          </div>
        </div>
        <div className="notes">
          *Note: Any associated Activities, Visits, Drafts will also be Deleted.
        </div>
        <div className="warningBtn mt-2">
          <Button variant="secondary" className="btn" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn" variant="danger" onClick={handleConfirm}>
            Confirm Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default DeleteConfirmationModal;
